module.exports = __webpack_public_path__ + "static/media/alarm-plus.44924395.svg";